import { render, staticRenderFns } from "./withholdingIncomTax.vue?vue&type=template&id=bbea63fe&scoped=true"
import script from "./withholdingIncomTax.vue?vue&type=script&lang=js"
export * from "./withholdingIncomTax.vue?vue&type=script&lang=js"
import style0 from "./withholdingIncomTax.vue?vue&type=style&index=0&id=bbea63fe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbea63fe",
  null
  
)

export default component.exports